import {StyleSheet} from 'aphrodite/no-important'

export default StyleSheet.create({
  container: {
    overflow: 'hidden',
    minWidth: '1024px',
    padding: '80px 0 0',
  },
})
